import {
  Box,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Divider,
} from '@mui/material'
import { useMemo } from 'react'
import { Chart, AxisOptions } from 'react-charts'

import DateRangePicker from './DateRangePicker'

export type UsageGraphDatachild = {
  date: string
  count: number
}

export type GraphDataType = Record<string, UsageGraphDatachild[]>

type Unit = 'day' | 'month'

interface Props {
  unit: Unit
  year: number
  month: number
  data?: GraphDataType
  onChangeRange: (y: number, m: number) => void
  handleUnitSelect: (unit: Unit) => void
}

export default function UsageGraphComp({
  unit,
  year,
  month,
  data,
  onChangeRange,
  handleUnitSelect,
}: Props) {
  const elType = 'line'

  const primaryAxis = useMemo(
    (): AxisOptions<UsageGraphDatachild> => ({
      getValue: (datum) => datum.date,
    }),
    [],
  )
  const secondaryAxes = useMemo(
    (): AxisOptions<UsageGraphDatachild>[] => [
      {
        max: 10,
        min: 0,
        getValue: (datum) => datum.count,
        elementType: elType,
      },
    ],
    [elType],
  )

  const gData: any[] = []
  if (data?.invoice) gData.push({ label: '請求書 OCR', data: data.invoice })
  if (data?.orderForm) gData.push({ label: '注文書 OCR', data: data.orderForm })
  if (data?.template) gData.push({ label: 'Template OCR', data: data.template })
  if (data?.general) gData.push({ label: 'テキスト・表', data: data.general })

  const options = {
    data: gData,
    primaryAxis,
    secondaryAxes,
  }

  // if (data?.every(d => d.data.length === 0)) return null

  const _handleUnitSelect = (e) => handleUnitSelect(e.target?.value)
  return (
    <Box style={{ minHeight: 500 }}>
      <Typography variant="body1" style={{ marginTop: '40px' }}>
        利用状況グラフ
      </Typography>
      <Divider style={{ marginTop: '15px', marginBottom: '10px' }} />
      <Box display="flex" alignItems="center" marginBottom={3}>
        <Typography variant="body1" style={{ marginRight: '10px' }}>
          コール数
        </Typography>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="day"
            name="radio-buttons-group"
            onChange={_handleUnitSelect}
          >
            <FormControlLabel
              value="day"
              control={<Radio style={{ color: 'green' }} data-testid="radio-day" />}
              label="日単位"
            />
            <FormControlLabel
              value="month"
              control={<Radio style={{ color: 'green' }} data-testid="radio-month" />}
              label="月単位"
            />
          </RadioGroup>
        </FormControl>
        <DateRangePicker unit={unit} year={year} month={month} onChange={onChangeRange} />
      </Box>
      <Box
        sx={{
          maxWidth: '1000px',
          minWidth: '800px',
          height: '460px',
        }}
      >
        <Chart options={options} data-testid="usage-graph-comp" />
      </Box>
    </Box>
  )
}
